import { Check } from "@mui/icons-material";
import BasicButton from "components/BasicInputs/BasicButton";
import StarIcon from "assets/icons/Plans/StarIcon.svg";
import CheckBox from "components/simple/CheckBox";
import Switch from "./Switch";
import { useEffect, useState } from "react";
import useDidUpdateEffect from "helpers/useDidUpdateEffect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
export interface Subscription {
  id: number;
  subPriceId: number
  subId: number;
  type: string;
  label: string;
  description: string;
  price: number;
  currency: string;
  details: string[];
  icon: string;
  expireDays?: number;
  productLimit: number;
  userLimit: number;
  accountingLimit: number;
  renewPrice: number;
  duration: number;
  durationTab: number;
  discount: number;
  suggested?: boolean;
  offline?: boolean;
  offlineCount?: number
  branchCount?: number

}
export interface CardProps {
  subscription: Subscription
  subscriptions: Subscription[]
  branchPrice: number
  offLinePrice: number
  active?: boolean;
  onChange?: (val: Subscription | null) => void;

}
export default function Card(props: CardProps) {
  const { active, subscription, subscriptions, offLinePrice, branchPrice } = props;
  const [offline, setoffline] = useState({ active: false, count: 0 })
  const [branch, setBranch] = useState({ active: false, count: 0 })
  const [currentSubscription, setCurrentSubscription] = useState(subscription)
  useDidUpdateEffect(() => {
    setCurrentSubscription(state => {
      const price = (subscription.price + offline.count * offLinePrice) + (branch.count * branchPrice)
      return {
        ...state,
        price,
        offlineCount: offline.count,
        branchCount: offline.count
      }
    })

    return () => {

    }
  }, [offline, branch])
  useDidUpdateEffect(() => {
    props.onChange && props.onChange(currentSubscription)
  }, [currentSubscription])
  return (
    <div className="transition-all">
      {currentSubscription.suggested && (
        <div className="flex gap-4 items-center w-full bg-yellow-2 px-6 py-2">
          <img src={StarIcon} alt="" className="w-5" />
          <span className="text-yellow-1 text-sm">پیشنهاد چرتکه</span>
        </div>
      )}
      <div
        className={`flex flex-col gap-4 w-full p-6 rounded-lg border cursor-pointer  ${active ? "border-blue-1 bg-blue-50" : "border-dark-10 hover:bg-blue-50 hover:border-blue-5"
          }`}
        onClick={() => props.onChange && props.onChange(active ? null : currentSubscription)}
      >
        <div id="top-section" className="flex justify-between items-start gap-4 flex-wrap">
          <div id="title-section" className="flex gap-4">
            <img src={currentSubscription.icon} alt="" className="w-14" />
            <div className="flex flex-col gap-2">
              <div className="flex gap-1 items-center">
                <div className="text-dark-2">اشتراک</div>
                <div className="text-lg font-medium text-dark-1">{currentSubscription.label}</div>
              </div>
              <div className="text-xs text-dark-3">
                <a href="https://www.chortke.app/plans-pricing-guide/" target="_blank" className="link-info"> {`امکانات بسته ${currentSubscription.label}`}</a>
              </div>
            </div>
          </div>
          <div id="price" className="flex items-center gap-1">
            <span className="text-dark-1 text-2xl">
              {Intl.NumberFormat().format(currentSubscription.price)}
            </span>
            <span className="text-dark-4 text-base">{currentSubscription.currency}</span>
          </div>
        </div>

        <div id="bottom-section" className="flex justify-between items-center flex-wrap md:flex-nowrap">
          {/* <div id="features" className="flex gap-4 flex-wrap whitespace-nowrap">
            {currentSubscription.details.map((x, index) => (
              <div key={index} className="flex items-end gap-1">
                <Check color="primary" />
                <span className="text-dark-2 text-sm">{x}</span>
              </div>
            ))}
          </div> */}
          <div className="flex flex-col gap-3" >
            <div className="flex gap-1  align-items-center" onClick={(ev) => { ev.stopPropagation() }} >
              <div className="flex gap-1">
                <span>نسخه آفلاین</span>
                <Switch size={2}
                  active={active && offline.active}
                  onChange={(active) => {
                    setoffline({
                      active,
                      count: active ? 1 : 0
                    })
                  }
                  }
                />

              </div>
              <div>
                {
                  offline.active && active && <BasicTextInput style={{
                    width: 140,
                    height: 30
                  }} type="number" min={0} max={currentSubscription.type === "base" ? 1 : currentSubscription.type === "standard" ? 3 : currentSubscription.type === "prog" ? 6 : 10} val={offline.count} onChange={(val) => {

                    setoffline(state => {
                      return {
                        ...state,
                        count: parseFloat(val.toString())
                      }
                    })
                  }} />

                }
              </div>

            </div>
            <div className="flex gap-1   align-items-center" onClick={(ev) => { ev.stopPropagation() }} >
              {!["base", "standard"].includes(currentSubscription.type) &&
                <>

                  <div className="flex gap-11">
                    <span>شعب</span>
                    <Switch size={2} active={active && branch.active}
                      onChange={(active) => {
                        setBranch({
                          active,
                          count: active ? 1 : 0
                        })

                      }
                      } />
                  </div>
                  <div>
                    {
                      branch.active && active && <BasicTextInput style={{
                        width: 140,
                        height: 30
                      }} type="number" min={0} max={currentSubscription.type === "prog" ? 2 : 10} val={branch.count} onChange={(val) => {

                        setBranch(state => {
                          return {
                            ...state,
                            count: parseFloat(val.toString())
                          }
                        })
                      }} />

                    }
                  </div>
                </>
              }
            </div>
          </div>
          <div id="checkbox">
            <BasicButton className={`text-blue-1 ${active ? "bg-blue-5" : ""} justify-start items-center`}>
              <div
                className={`rounded border border-blue-1 flex justify-center items-center w-5 h-5 p-2 ${active ? "bg-blue-1" : ""
                  }`}
              >
                {active && <Check className="text-white" style={{ width: 14 }} />}
              </div>
              <span>{active ? "انتخاب شده" : "انتخاب"}</span>
            </BasicButton>

          </div>
        </div>
      </div>
    </div>
  );
}
